import styles from "../styles/home.module.scss";


const Installation = () => {

    return ( 
        <div className={styles["Installation-container"]}>
            <div className={styles["title"]}>Installation</div>
            <div className={styles["primary-title"]}>Using ⚡️ Swifty Config for the first time.</div>
            <div className={styles["inner-container"]}>
                <p>Install swifty-config using your Command Line</p>
                <div>
                    <code>$ npm i create-swifty-config</code>
                </div>
            </div>
            <div className={styles["inner-container"]}>
                <p>Setup your app</p>
                <h4>with npm:</h4>
                <div>
                    <code>$ npm create swifty-config</code>
                </div>
                <h4>with yarn:</h4>
                <div>
                    <code>$ npm create swifty-config</code>
                </div>
                <h3>Then follow the prompts to setup the project!</h3>
            </div>

        </div>
     );
}
 
export default Installation;